var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Col, Row } from "@folio/stripes/components";
import { Controller } from "react-hook-form";
import { AccordionSection } from "../../../AccordionSection";
import { RecekDatepicker } from "../../../inputs";
import { DISPLAY_DATE_FORMAT } from "../../../../utils/dateUtils";
export var PeriodSection = function (_a) {
    var control = _a.control, open = _a.open, onToggle = _a.onToggle;
    return (React.createElement(AccordionSection, { id: "progress-report-period", labelId: "ui-br-agency.outputs.progress-report.section.period", open: open, onToggle: onToggle },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "periodFrom", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekDatepicker, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.periodFrom", backendDateStandard: "ISO 8601", dateFormat: DISPLAY_DATE_FORMAT, error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                    } })),
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "periodTo", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekDatepicker, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.periodTo", backendDateStandard: "ISO 8601", dateFormat: DISPLAY_DATE_FORMAT, error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                    } })))));
};
